export function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export function getRandomBytes() {
  if (!('crypto' in global)) {
    return uuid().replace(/\-/g, '')
  }

  return randomHex128()
}

export function hex(bytes: Uint8Array) {
  // Convert a Uint8Array to a hex string.
  return Array.prototype.map
    .call(bytes, (b: any) => ('00' + b.toString(16)).slice(-2))
    .join('')
}

export function randomHex128() {
  // Return a random hex number of 128 bits.
  const array = new Uint8Array(16)
  crypto.getRandomValues(array)
  return hex(array)
}



// WEBPACK FOOTER //
// ./src/lib/get-random-bytes.ts